import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class RefreshService  {

    public componentObject: any;
    public showMessage: boolean =  false;

    constructor(private router: Router) { }

    onRefresh(storeData?: any) {
        this.router.routeReuseStrategy.shouldReuseRoute = function () { return false; };

        let currentUrl = this.router.url + '?';

        this.componentObject = storeData;

        this.router.navigateByUrl(currentUrl)
            .then(() => {
                this.showMessage = true;
                this.router.navigated = false;
                this.router.navigate([this.router.url]);
            });
    }
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/refresh.service.ts